<template>
  <v-layout column>
    <v-layout
      align-end
      class="my-2"
    >
      <v-flex xs6>
        <app-reference
          v-model="entity.Country"
          :outline="true"
          class="mx-2 my-0"
          label="Страна отправления*"
          :rules="[v => !!v || '']"
          :height-field="44"
          resource="countries"
          component-name="Country"
          :error="checkMissingElement(entity.Country, true)"
          :scroll-value="scrollValue"
          :disabled="disabled"
          @input="clearSender"
        />
      </v-flex>
      <v-flex xs6>
        <app-reference
          v-model="entity.SenderWarehouse"
          :outline="true"
          class="mx-2 my-0"
          label="Склад*"
          resource="warehouses"
          component-name="Warehouse"
          parent-filter="countryId"
          :parent-id="entity.Country ? entity.Country.id : 0"
          filter-name="groupedWarehouse"
          :filter-value="senderWarehouseFilter"
          :without-parent-lock="true"
          :height-field="44"
          :rules="[v => !!v || '']"
          :error="checkMissingElement(entity.SenderWarehouse, true)"
          :scroll-value="scrollValue"
          @input="warehouseChanged"
        />
      </v-flex>
    </v-layout>

    <v-layout
      align-end
      class="my-2"
    >
      <v-flex xs12>
        <app-tiny-reference
          ref="client-alias"
          v-model="entity.ClientAlias"
          :outline="true"
          class="mx-2 my-0"
          label="Клиент по документам*"
          resource="clients/aliases"
          parent-filter="clientId"
          :parent-id="entity.Client ? entity.Client.id : 0"
          :without-length-lock="true"
          :height-field="44"
          :scroll-value="scrollValue"
          :rules="[v => !!v || '']"
          :error="checkMissingElement(entity.ClientAlias, true)"
          @input="handleEntityChange"
        >
          <template v-slot:append-content="slotProps">
            <v-layout align-end>
              <v-text-field
                v-model="newClientAlias"
                outline
                class="px-1 pt-0 mt-0 text-field-size"
                placeholder="Добавить название"
                hide-details
                height="44"
              />
              <v-divider horisontal />
              <v-spacer />
              <v-btn
                small
                :disabled="newClientAlias.length < 1"
                class="ma-0 ml-0 mr-1 plus-button"
                @click="saveNewClientAlias(slotProps.items)"
              >
                <v-icon>add</v-icon>
              </v-btn>
            </v-layout>
          </template>
        </app-tiny-reference>
      </v-flex>
    </v-layout>
    <v-layout
      align-end
      class="my-2"
    >
      <v-flex xs12>
        <v-textarea
          slot="activator"
          v-model="entity.LoadingNumber"
          outline
          class="mx-2 my-0"
          label="Референс погрузки"
          hide-details
          rows="1"
          auto-grow
          @input="handleEntityChange"
        />
      </v-flex>
    </v-layout>

    <v-layout
      align-end
      class="my-2"
    >
      <v-flex xs6>
        <v-text-field
          :value="entity.LoadingAddress ? entity.LoadingAddress.title : ''"
          outline
          class="mx-2 my-0"
          label="Адрес погрузки*"
          :rules="[v => !!v || '']"
          :disabled="disabled"
          hide-details
          height="44"
        />
      </v-flex>
      <v-flex xs6>
        <v-text-field
          v-model="entity.LoadingPlaceTimetable"
          outline
          class="mx-2 my-0"
          label="Время работы места погрузки"
          hide-details
          height="44"
        />
      </v-flex>
    </v-layout>
    <LoadingContacts
      :value="entity.ContactsLoading"
      :warehouse-id="entity.SenderWarehouse ? entity.SenderWarehouse.id : 0"
      :scroll-value="scrollValue"
      :entity-id="entity.Id"
      sender-type="WAREHOUSE"
      @change="contactsLoadingChanged"
    />
  </v-layout>
</template>

<script>
import LoadingContacts from "./LoadingContacts.vue";
import { updateNewClientAlias } from "../../../../backend/newShippingApi.js";
import * as shippingsApi from "../../../../backend/shippingsApi.js";

export default {
  components: {
    LoadingContacts,
  },
  props: [
    "entity",
    "isHighlightLabel",
    "scrollValue",
    "warehouseMode",
    "changedSenderType",
    "disabled",
    "changeInfo",
  ],
  data() {
    return {
      newClientAlias: "",
    };
  },
  computed: {
    senderWarehouseFilter() {
      return this.warehouseMode === "groupedWarehouse" ? true : false;
    },
  },
  watch: {
    warehouseMode() {
      this.clearSender();
    },
    changeInfo: {
      handler(val) {
        if (val && !!this.entity.LoadingNumber) {
          this.entity.LoadingNumber = this.entity.LoadingNumber.replace(/\n/g, "; ");
        }
      },
      immediate: true,
    },
  },
  created() {
    if (this.entity.Id && !this.changedSenderType) {
      return;
    }
    this.clearSender();
  },
  methods: {
    handleEntityChange() {
      this.$emit("handleEntityChange");
    },
    clearSender() {
      this.entity.LoadingAddress = null;
      this.entity.SenderWarehouse = null;
      this.entity.ContactsLoading = [];
      this.entity.LoadingPlaceTimetable = "";
    },
    async saveNewClientAlias(items) {
      await updateNewClientAlias(this.entity.Client.id, this.newClientAlias);
      this.entity.ClientAlias = this.newClientAlias;
      items.push({ value: this.newClientAlias, text: this.newClientAlias });
      this.$refs["client-alias"].$children[0].blur();
      this.newClientAlias = "";
    },
    async warehouseChanged() {
      this.entity.LoadingAddress = null;
      this.entity.ContactsLoading = [];
      this.entity.LoadingPlaceTimetable = null;

      if (!this.entity.SenderWarehouse) {
        return;
      }

      const response = await shippingsApi.getWarehouse(
        this.entity.SenderWarehouse.id,
      );
      if (response.Country) {
        this.$set(this.entity, "Country", {
          id: response.Country.Id,
          title: response.Country.Title,
        });
      }
      if (response.Address) {
        this.$set(this.entity, "LoadingAddress", {
          id: response.Address.Id,
          title: response.Address.Title,
        });
      }
      if (response.Timetable) {
        this.$set(this.entity, "LoadingPlaceTimetable", response.Timetable);
      }
      if (response && response.Contacts.length === 1) {
        this.$set(this.entity, "ContactsLoading", [
          {
            id: 0,
            contactPerson: {
              id: response.Contacts[0].Id,
              title: response.Contacts[0].FullName,
            },
            contactPhone: response.Contacts[0].Phones.length
              ? response.Contacts[0].Phones.map(p =>
                this.$options.filters.phoneInternational(p),
              ).join("; ")
              : "",
            contactEmail: response.Contacts[0].Emails.length
              ? response.Contacts[0].Emails.join("; ")
              : "",
          },
        ]);
      }
    },
    contactsLoadingChanged(contactDetails) {
      this.entity.ContactsLoading = [];
      this.$set(this.entity, "ContactsLoading", contactDetails);
      this.handleEntityChange();
    },
    checkMissingElement(value, required) {
      if (!this.isHighlightLabel) {
        return;
      }
      if (!value && !required) {
        return "label-color";
      }
      if (!value && required) {
        return true;
      }
    },
  },
};
</script>
